//
const data = {
  //
  //
  recentSearches: [
    {
      label: "FARMPOWER Self Propelled Boom Sprayer",
      path: "/new-implements/1/FARMPOWER Self Propelled Boom Sprayer/",
    },
    {
      label: "FARMPOWER- ROTAVATOR- SUPREME Series",
      path: "/new-implements/2/FARMPOWER- ROTAVATOR- SUPREME Series/",
    },
    {
      label: "FARMPOWER - Mini Round Baler - SBA330",
      path: "/new-implements/5/FARMPOWER - Mini Round Baler - SBA330/",
    },
  ],
  popularSearches: [
    {
      label: "FARMPOWER Self Propelled Boom Sprayer",
      path: "/new-implements/1/FARMPOWER Self Propelled Boom Sprayer/",
    },
    {
      label: "Self Propelled Combine Harvester",
      path: "/new-implements/1/FARMPOWER Self Propelled Boom Sprayer/",
    },
    {
      label: "Tractor Mounted Boom Sprayer",
      path: "/new-implements/1/FARMPOWER Self Propelled Boom Sprayer/",
    },
    {
      label: "FARMPOWER ROTAVATOR XXTRA DUM",
      path: "#",
    },
    {
      label: "FARMPOWER Mini Round Baler BRB500 Armless Type",
      path: "#",
    },
    {
      label: "Bull Agro, Mini Round Baler, BRB500 Tech Plus, Scaleless Type",
      path: "#",
    },
  ],
  //
  //
};

//
//
export const getSearchDataList = async () => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(data);
    }, 2000);
  });
};
